module.exports = __webpack_public_path__ + "img/top_info.d130a13c.png";